import { StatusE, UserRoleE } from "../../models/enums";

export default (
  versionStatus: StatusE,
  userRole: UserRoleE,
  isMXF: boolean,
  fileFormat: string
) => {
  if (
    !userRole ||
    !versionStatus ||
    window.location.pathname.includes("campaigns")
  ) {
    return false;
  }

  if (
    (userRole === UserRoleE.PostProduction ||
      userRole === UserRoleE.DeliveryService) &&
    (versionStatus === StatusE.Opened ||
      versionStatus === StatusE.UploadingFiles)
  ) {
    return true;
  }

  if (
    isMXF &&
    fileFormat !== "MP4" &&
    (userRole === UserRoleE.AdvertisingAgency ||
      userRole === UserRoleE.Broadcaster) &&
    (versionStatus === StatusE.DownloadedByAllBroadcasters ||
      versionStatus === StatusE.DownloadedByBroadcaster)
  ) {
    return true;
  }

  return false;
};
